<script>
import pageHeader from '@components/layout/page/page-header'

export default {
  components: {
    PageHeader: pageHeader,
  },
  data() {
    return {}
  },
}
</script>

<template>
  <div class="app-content">
    <slot name="page-header">
      <PageHeader v-if="$slots.heading">
        <slot name="heading" slot="heading" />
        <slot name="tools" slot="tools" />
      </PageHeader>
    </slot>

    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}
</style>
